import Swal from 'sweetalert2';
export class GoogleStorage {
    static async uploadFileFromSignedUrl(signedUrl, file, uploadRequest) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('PUT', signedUrl, true);
            xhr.onload = async () => {
                const status = xhr.status;
                if (status == 200)
                    resolve(true);
                else {
                    Swal.fire({
                        title: 'There was a problem with the upload',
                        text: 'We could not verify this upload request. Please try again.',
                        icon: 'error'
                    });
                }
            };
            xhr.upload.addEventListener('progress', evt => {
                const progress = Math.ceil((evt.loaded / file.size) * 100);
                if (uploadRequest && uploadRequest.onProgress)
                    uploadRequest.onProgress(progress);
            });
            xhr.send(file);
        });
    }
}
